import { deClientPortalAssetListPage } from './AssetList/AssetListPage'

export const deClientPortalAssetListPages = {
    assetListPage: deClientPortalAssetListPage,
}
